<template>
    <div>
        <h1 class="text-center mt-4 d-none d-lg-block">Gracias por utilizar nuestro servicio de autofacturaci&oacute;n</h1>
        <h4 class="text-center mt-4 d-lg-none">Gracias por utilizar nuestro servicio de autofacturaci&oacute;n</h4>

        <h4 class="text-center d-none d-lg-block">Su nota de venta ha sido facturada correctamente</h4>
        <h5 class="text-center d-lg-none">Su nota de venta ha sido facturada correctamente</h5>

        <div class="card mt-md-5">
            <div class="card-body px-md-5 py-4">
                <h4 class="text-center mt-4">
                    <b-icon icon="check-box"></b-icon>
                    Su CDFI ha sido enviado al correo de: <b
                        class="text-success">{{email}}</b></h4>
                <br>
                <br>
                <div class="row">
                    <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                        <button @click="downloadXml" class="btn btn-secondary btn-lg btn-block mb-2">
                            <b>
                                <b-icon icon="file-earmark-code"></b-icon>
                                Descargar XML
                            </b>
                        </button>
                    </div>
                    <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                        <button @click="downloadPdf" class="btn btn-orange btn-lg btn-block mb-2">
                            <b>
                                <b-icon icon="file-earmark-text"></b-icon>
                                Descargar PDF
                            </b>
                        </button>
                    </div>
                </div>
                <br>
                <br>

                <router-link tag="button" :to="{ name: 'Start' }" class="float-right btn btn-light border">
                    <b>
                        <b-icon icon="box-arrow-in-right"></b-icon>
                        Salir
                    </b>
                </router-link>
            </div>
        </div>
    </div>
</template>

<script>

    export default {
        name: 'Thanks',
        props: {
            email: String,
            uuid: [String, Number],
        },

        mounted() {
            this.$store.dispatch('note/clearAuth');

            if (!this.uuid) {
                this.$router.push({name: 'SearchNote'})
            }
        },
        methods: {

            downloadXml() {
                this.$store.dispatch('invoice/downloadXml', this.uuid)
                    .then(res => {
                        this.downloadFile(res)
                    }).catch(err => {
                        if (err.response.data.error) {
                            this.msgAlert(err.response.data.error);
                            console.log(err.response.data.error)
                        } else {
                            this.msgAlert(err.response.data.validations[0].error);
                            console.log(err.response.data.validations[0].error)
                        }
                });

            },

            downloadPdf() {
                this.$store.dispatch('invoice/downloadPdf', this.uuid)
                    .then(res => {
                        this.downloadFile(res)
                    }).catch(err => {
                    if (err.response.data.error) {
                        this.msgAlert(err.response.data.error);
                        console.log(err.response.data.error)
                    } else {
                        this.msgAlert(err.response.data.validations[0].error);
                        console.log(err.response.data.validations[0].error)
                    }
                });
            },

            downloadFile(result) {
                let filename = '';
                let filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
                let matches = filenameRegex.exec(result.headers['content-disposition']);
                if (matches != null && matches[1]) {
                    filename = matches[1].replace(/['"]/g, '');
                }

                if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                    window.navigator.msSaveOrOpenBlob(new Blob([result.data]), filename);
                }else{
                    const downloadUrl = window.URL.createObjectURL(new Blob([result.data]));
                    const link = document.createElement('a');
                    link.href = downloadUrl;
                    link.setAttribute('download', filename);
                    document.body.appendChild(link);
                    link.click();
                    link.remove();
                }


            },

            msgAlert(err) {
                this.$bvModal.msgBoxOk(err, {
                    title: 'Ocurrió un problema al realizar descarga',
                    size: 'sm',
                    buttonSize: 'sm',
                    okVariant: 'primary',
                    headerClass: 'p-2 border-bottom-0',
                    footerClass: 'p-2 border-top-0',
                    centered: true
                }).then(() => {
                    setTimeout(() => {
                        this.$refs.txtnote.focus()
                    }, 400);

                });
            }
        }
    }
</script>